import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const Wrapper = styled.div`
  text-align: ${props => props.textAlign};
  &:first-letter {
    text-transform: uppercase;
  }
`

const Sell = styled.span`
  font-size: 13px;
  color: ${({ theme }) => theme.down};
`

const Buy = styled.span`
  font-size: 13px;
  color: #00c087;
`

class Side extends PureComponent {
  static propTypes = {
    text: PropTypes.string,
    textAlign: PropTypes.string,
  }

  static defaultProps = {
    text: '',
    textAlign: 'left',
  }

  render() {
    const { text, textAlign } = this.props
    return (
      <Wrapper textAlign={textAlign}>
        {text.toUpperCase() === 'SELL' && <Sell>{text}</Sell>}
        {text.toUpperCase() === 'BUY' && <Buy>{text}</Buy>}
        {text.toUpperCase() === 'SELF' && text}
      </Wrapper>
    )
  }
}

export default Side
